import { Autoplay, Keyboard, Pagination } from "swiper/modules";

export const ProductSettings = {
    slidesPerView: 4,
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    spaceBetween: 30,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    breakpoints: {
        176: { slidesPerView: 1.7 },
        768: { slidesPerView: 3 },
        1000: { slidesPerView: 6 },
    },
    autoplay: {
        delay: 5500,
    },
    pagination: {
        clickable: true,
    },
    modules: [Keyboard, Pagination, Autoplay],
    className: "mySwiper pb-0",
};


export const CategorySettings = {
    slidesPerView: 4,
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    spaceBetween: 30,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    breakpoints: {
        176: { slidesPerView: 1.7 },
        768: { slidesPerView: 2.3 },
        1000: { slidesPerView: 4 },
    },
    autoplay: {
        delay: 5500,
    },
    pagination: {
        clickable: true,
    },
    modules: [Keyboard, Pagination, Autoplay],
    className: "mySwiper pb-0",
};

export const ProductBlogSettings = {
    slidesPerView: 4,
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    spaceBetween: 20,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    breakpoints: {
        176: { slidesPerView: 1.4 },
        768: { slidesPerView: 3 },
        1000: { slidesPerView: 5 },
    },
    autoplay: {
        delay: 5500,
    },
    modules: [Keyboard, Autoplay],
    className: "mySwiper",
};

export const ProductsSettings = {
    slidesPerView: 4,
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    spaceBetween: 30,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    autoplay: {
        delay: 5500,
    },
    breakpoints: {
        176: { slidesPerView: 1.7 },
        768: { slidesPerView: 3 },
        1000: { slidesPerView: 6 },
    },
    pagination: {
        clickable: true,
    },
    modules: [Keyboard, Pagination, Autoplay],
    className: "mySwiper pb-4",
};

export const ProductsSettingsDes = {
    slidesPerView: 4,
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    spaceBetween: 30,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    autoplay: {
        delay: 5500,
    },
    breakpoints: {
        176: { slidesPerView: 1.3 },
        768: { slidesPerView: 3 },
        1000: { slidesPerView: 6 },
    },
    pagination: {
        clickable: true,
    },
    modules: [Keyboard, Pagination, Autoplay],
    className: "mySwiper pb-4",
};

export const BlogsSettings = {
    slidesPerView: 4,
    centeredSlides: false,
    slidesPerGroupSkip: 1,
    spaceBetween: 30,
    grabCursor: true,
    keyboard: {
        enabled: true,
    },
    autoplay: {
        delay: 5500,
    },
    breakpoints: {
        176: { slidesPerView: 1.7 },
        768: { slidesPerView: 3 },
        1000: { slidesPerView: 5 },
    },
    pagination: {
        clickable: true,
    },
    modules: [Keyboard, Pagination, Autoplay],
    className: "mySwiper pb-4",
};